import { z } from 'zod';

export const envSchema = z.object({
    VITE_MAPBOX_TOKEN: z.string().min(1),
    VITE_MODE: z.enum(['development', 'main', 'prod', 'local']).default('development'),
});

export type TEnv = z.infer<typeof envSchema>;
